import { apiClient } from ".";
import { useMutation } from "@tanstack/react-query";

export const startSignIn = async ({
  personalNumber,
  transactionId,
}: {
  personalNumber: string;
  transactionId: string;
}) => {
  const response = await apiClient({
    url: `/auth/sign-in`,
    method: "POST",
    data: {
      username: personalNumber,
      transactionId,
    },
  });
  return response.data;
};

export const useStartSignIn = () =>
  useMutation({
    mutationFn: ({
      personalNumber,
      transactionId,
    }: {
      personalNumber: string;
      transactionId: string;
    }) => startSignIn({ personalNumber, transactionId }),
  });
